export default __webpack_public_path__ + "static/media/promo-c.123900f1.png";